import * as React from 'react'
import * as domain from '@packages/domain'
import styled from 'styled-components'
import { BasePost } from '../Posts/BasePost'
import { CategoryTitle } from '../components/CategoryTitle'

export interface PodcastProps {
  post: domain.Podcast.Type
}

const Description = styled.div`
  margin-bottom: 1rem;

  &,
  & > p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  & > p {
    margin-bottom: 0;
  }
`

export const Podcast: React.VFC<PodcastProps> = ({ post }) => {
  return (
    <BasePost post={post} title={<CategoryTitle name={'Podcast'} icon={'fa-solid fa-headphones'} />}>
      <Description dangerouslySetInnerHTML={{ __html: post.description }} />
    </BasePost>
  )
}
